import React, { useState } from "react";
import swal from "sweetalert";
import { TooltipComponent } from "../../Component";
import { resolvePartnerOrganizationLogoUrl } from "./medicalPartnerAdminConstants";
import {
  partnerListNeedsAccountAttention,
  partnerPrimaryUserAccountSuspended,
} from "./medicalPartnerListTableHelpers";
import MedicalPartnerListInlineTextField from "./MedicalPartnerListInlineTextField";

function organizationInitials(name) {
  const s = String(name || "").trim();
  if (!s) return "?";
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase().slice(0, 2);
  }
  return s.slice(0, 2).toUpperCase();
}

const AVATAR_PX = 40;

const MedicalPartnerListOrganizationColumn = ({ item, rowId, onPatchPartner, patchBusy = false }) => {
  const [logoFailed, setLogoFailed] = useState(false);
  const logoSrc = resolvePartnerOrganizationLogoUrl(item);
  const showLogo = Boolean(logoSrc && !logoFailed);
  const needsAttention = partnerListNeedsAccountAttention(item);
  const primaryUserSuspended = partnerPrimaryUserAccountSuspended(item);
  const safeRowId = rowId || item?._id || "row";
  const pid = item?._id;

  const patchOrgName = (next) => {
    if (!pid) return;
    if (!next) {
      swal("Validation", "Organization name cannot be empty.", "warning");
      return;
    }
    onPatchPartner(pid, { organization_name: next });
  };

  return (
    <div className="d-flex align-items-start" style={{ maxWidth: 380 }}>
      <div
        className="rounded border bg-white flex-shrink-0 d-flex align-items-center justify-content-center overflow-hidden text-uppercase text-soft small fw-bold mr-3"
        style={{ width: AVATAR_PX, height: AVATAR_PX, fontSize: "0.7rem" }}
      >
        {showLogo ? (
          <img
            src={logoSrc}
            alt=""
            width={AVATAR_PX}
            height={AVATAR_PX}
            className="w-100 h-100"
            style={{ objectFit: "cover" }}
            onError={() => setLogoFailed(true)}
          />
        ) : (
          organizationInitials(item.organization_name)
        )}
      </div>
      <div className="medical-partner-list__org-stack min-w-0 flex-grow-1 d-flex flex-column medical-partner-list__org-stack--no-manager">
        <div className="medical-partner-list__org-name-row d-flex align-items-center flex-wrap min-w-0">
          <div className="medical-partner-list__org-name min-w-0 flex-grow-1">
            <MedicalPartnerListInlineTextField
              ariaLabel="Organization name"
              defaultValue={item.organization_name || ""}
              onCommit={patchOrgName}
              disabled={patchBusy}
              placeholder="Organization name"
            />
          </div>
          {primaryUserSuspended ? (
            <TooltipComponent
              id={`partner-user-suspended-${safeRowId}`}
              tag="button"
              type="button"
              containerClassName="badge badge-dim badge-danger p-1 border-0 d-inline-flex align-items-center"
              icon="shield-alert"
              direction="top"
              text="Primary user account looks disabled or suspended while the partner can still be active in workflow — check Users and re-enable or relink."
            />
          ) : null}
          {needsAttention ? (
            <TooltipComponent
              id={`partner-account-attn-${safeRowId}`}
              tag="button"
              type="button"
              containerClassName="badge badge-dim badge-warning p-1 border-0 d-inline-flex align-items-center"
              icon="alert-circle"
              direction="top"
              text="Primary account link or role needs review — use Contact to assign the correct user."
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MedicalPartnerListOrganizationColumn;
